// sync actions
const CHANGE_TAB = 'settings-for-view/CHANGE_TAB';
const CHANGE_PAGE = 'settings-for-view/CHANGE_PAGE';

export default {
  CHANGE_TAB,
  CHANGE_PAGE,
};
